import classnames from 'classnames';
import { useMemo } from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const useClassNames = /* @__PURE__ */ __name((...props) => useMemo(() => classnames(...props), [props]), "useClassNames");

export { useClassNames };
//# sourceMappingURL=use-class-names.js.map
